export default __webpack_public_path__ + "static/media/White_Cloud_large_7.a4a4b47b.jpg";